<template>
	<div class="flex_jc" style="position: relative; min-height: 100vh; background-color: #f2f2f2">
		<!-- 密码登录 -->
		<div class="box_login">
			<div class="flex_jc">
				<div class="div_pwp">{{$t('login.title')}}</div>
			</div>
			<el-form :model="loginForm" :rules="rules" ref="form" label-position="top" label-width="80px"
				class="demo-loginForm">
				<el-form-item prop="email" style="margin-bottom: 0px">
					<el-input v-model="loginForm.email" :placeholder="$t('login.email_placeholder')"></el-input>
				</el-form-item>
				<el-form-item prop="pwd" style="margin-bottom: 0px">
					<el-input v-model="loginForm.pwd" type="password" :placeholder="$t('login.pwd_placeholder')"
						style="margin: 20px 0"></el-input>
				</el-form-item>
				<div class="flex_jc top_up">
					<el-button type="primary" round style="width: 300px"
						@click="submitForm">{{$t('login.submit_button_title')}}</el-button>
				</div>
			</el-form>
			<div class="flex_jc top_up" style="color: #666666">
				<div class="f14" style="cursor: pointer" @click="toForget">{{$t('login.forget_txt')}}</div>
				<div class="f14" style="margin: 0 20px">|</div>
				<div class="f14" style="cursor: pointer" @click="toReg">{{$t('login.register_txt')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		login
	} from '@/api/login';
	import {
		setToken
	} from '@/utils/auth'
	import eventBus from '@/utils/eventBus'
	export default {
		name: "LoginPage",
		data() {
			return {
				input: '',
				is_login: true,
				loginForm: {
					email: "",//"41743656@qq.com",
					pwd: ""
				},
				rules: {
					email: [{
						required: true,
						message: "",
						trigger: "blur"
					}],
					pwd: [{
						required: true,
						message: "",
						trigger: "blur"
					}],
				}
			};
		},
		created() {
			let token = localStorage.getItem('App-Token') || ''
			if (token == '') {
				// this.$router.push({
				// 	path: '/login'
				// })
			} else {
				// 
			}
			this.rules.email[0].message = this.$t('login.email_rule')
			this.rules.pwd[0].message = this.$t('login.pwd_rule')
		},
		methods: {
			toForget() {
				this.$router.push({
					name: 'find'
				})
			},
			toReg() {
				this.$router.push({
					path: '/register'
				})
			},
			submitForm2() {
				eventBus.emit('update-user', {
					nickname: 'sony'
				})
			},
			submitForm() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						// this.$store.dispatch("Login", this.loginForm).then(() => {
						// 	this.$router.push({
						// 		path: this.redirect || "/"
						// 	}).catch(() => {})
						// }).catch(() => {

						// })
						login(this.loginForm).then(res => {
							if (res.code == 200) {
								console.log(res)
								setToken(res.data.token)
								localStorage.setItem('user', JSON.stringify(res.data.user))
								eventBus.emit('update-user', res.data.user)
								this.$router.push({
									name: 'index'
								})
							} else {
								this.$modal.msgError(res.msg)
							}
						})
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			reset(formName) {
				this.$refs[formName].resetFields();
			},
		},
	};
</script>

<style>
	.el-form--label-top .el-form-item__label {
		padding: 0 !important;
	}

	@media (max-width: 768px) {
		.div_pwp {
			min-width: 80px !important;
			font-size: 20px !important;
			text-align: center;
			font-weight: bold;
			margin-bottom: 30px;
			border-bottom: 5px solid #4679f0;
		}

		.box_login {
			width: 80% !important;
			background-color: #fff;
			border-radius: 20px;
			padding: 30px;
			padding: 30px;
			position: absolute;
			top: 40%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.box_login1 {
			width: 80% !important;
		}
	}

	.div_pwp {
		min-width: 115px;
		font-size: 28px;
		text-align: center;
		font-weight: bold;
		margin-bottom: 30px;
		border-bottom: 5px solid #4679f0;
	}

	.box_login {
		width: 25%;
		background-color: #fff;
		border-radius: 20px;
		padding: 30px;
		padding: 30px;
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
</style>